import React from 'react';
import _ from 'underscore';
import classNames from 'classnames';
import { submitEvent } from '../event-wrappers';
import { NodeOperations, DefaultIconsClassNameMap } from '../constants';
import { ExpandableNodeShape } from '../shapes';
import { getNodeRenderOptions } from '../nodes';

export const ExpandableNode = ({
  node,
  onChange,
  children,
  getClassNames,
  iconsClassNameMap,
  singleClickExpansion,
  expandIconAriaLabel,
}) => {
  const { isExpandable, isIconHidden, isExpanded } = getNodeRenderOptions(node);
  const handleChange = () => {
    const updatedNode = _.extend({}, node);

    updatedNode.state = _.extend({}, updatedNode.state, {
      expanded: !isExpanded,
    });
    onChange({
      node: updatedNode,
      type: updatedNode.state.expanded ? NodeOperations.EXPANDED : NodeOperations.COLLAPSED,
    });
  };
  const iconClassNameMap = _.extend({}, DefaultIconsClassNameMap, iconsClassNameMap);
  const iconClassNames = classNames({
    [iconClassNameMap.expanded]: isExpandable && isExpanded,
    [iconClassNameMap.collapsed]: isExpandable && !isExpanded,
    [iconClassNameMap.lastChild]: !isExpandable,
  });

  let expandIcon;
  if (isExpandable && !isIconHidden) {
    expandIcon = (
      <span
        role="button"
        tabIndex="0"
        onKeyDown={submitEvent(handleChange)}
        onClick={handleChange}
        className={iconClassNames}
        aria-label={expandIconAriaLabel}
        aria-expanded={isExpanded}
        data-is-focusable
      />
    );
  } else {
    expandIcon = (
      <span className={`${iconClassNames} tree-view-expandable-node`} />
    );
  }

  // Child elements with button or link properties will trigger onClick handler of parent
  return (
    <span
      onDoubleClick={!singleClickExpansion ? handleChange : undefined}
      onClick={singleClickExpansion ? handleChange : undefined}
      className={classNames(getClassNames(node))}
      role="presentation"
    >
      { expandIcon }
      { children }
    </span>
  );
};

ExpandableNode.propTypes = ExpandableNodeShape;

ExpandableNode.defaultProps = {
  singleClickExpansion: false,
  getClassNames: _.noop,
  iconsClassNameMap: {},
  expandIconAriaLabel: undefined,
};
